import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { qualtrics } from '@uhg-abyss/web/tools/event/listeners/qualtrics';
import { adobeAnalytics } from '@uhg-abyss/web/tools/event/listeners/adobeAnalytics';
import { qualtricsTags } from './tags/qualtrics';
import { adobeTags } from './tags/adobe';
import { asyncMessagingTags } from '@src/app/tools/analytics/tags/asyncMessaging';
import { asyncMessaging } from '@src/app/tools/asyncMessaging';
import { elasticApmAnalytics } from './elasticApm';
import { elasticApmTags } from './tags/elasticApm';

export const registerAnalytics = (data, qualtricsLink, liveChatUrl) => {
  event.listener(
    adobeAnalytics({
      id: 'adobe-analytics-digital-security',
      enabled: config('ANALYTICS_TRACKING'),
      logging: config('ANALYTICS_LOGGING'),
      events: adobeTags,
      metadata: data,
    })
  );

  event.listener(
    qualtrics({
      id: 'qualtrics-digital-security',
      url: qualtricsLink,
      logging: config('ANALYTICS_LOGGING'),
      enabled: true,
      events: qualtricsTags,
      metadata: data,
    })
  );

  event.listener(
    elasticApmAnalytics({
      id: 'elastic-apm',
      enabled: true,
      logging: true,
      events: elasticApmTags,
      metadata: data,
    })
  );
  event.listener(
    asyncMessaging({
      id: 'async-messaging-liveperson',
      enabled: data,
      logging: true,
      events: asyncMessagingTags,
      metadata: data,
      liveChatUrl,
    })
  );
};
